(function () {
    'use strict';

    angular.module('ib-grey-bar-module', ['ib-login-module']);
})();